import { TableRow } from "@mui/material";
import {
  NumberOfNumberCell,
  PublishedCell,
  RiskRatingCell,
  SecurityScoreCell,
  TitleCell,
} from "~/components/Cells";
import { Fragment } from "react/jsx-runtime";
import { policyIcon } from "~/pages/inventory/utils/policyIcon";
import { useAssetReport } from "../hooks/useAssetReport";
import { AssetReportScoreDetailSection } from "~/pages/reports/AssetReport/components/AssetReportScoreDetailsSection";
import { ReportsSectionHeading } from "~/pages/reports/components/ReportsSectionHeading";

export function AssetReportScoreDetails() {
  const { scoreDetailsData } = useAssetReport();

  return (
    <Fragment>
      <ReportsSectionHeading
        heading="Asset score details"
        disableUpperPadding
      />
      <AssetReportScoreDetailSection data={scoreDetailsData.vulnerabilities}>
        {scoreDetailsData.vulnerabilities.listItems.map((item) => {
          return (
            <TableRow key={item?.id}>
              <TitleCell
                title={item.id}
                detailText={item.title}
                tags={item.tags}
              />
              <RiskRatingCell
                rating={{ rating: item?.rating, value: item.riskValue ?? 0 }}
              />
              <PublishedCell date={item?.publishedAt ?? ""} />
            </TableRow>
          );
        })}
      </AssetReportScoreDetailSection>
      <AssetReportScoreDetailSection data={scoreDetailsData.security}>
        {scoreDetailsData.security.listItems.map((policy) => {
          const policyChecks = policy.scoreStats?.total ?? 0;
          let totalChecks = scoreDetailsData.security.totalChecks ?? 0;
          const icon = policyIcon(policy.name);
          return (
            <TableRow key={policy.mrn}>
              <TitleCell title={policy?.name ?? ""} icon={icon} />
              <RiskRatingCell
                showValue
                rating={{
                  rating: policy.score.riskRating,
                  value: policy.score.riskValue,
                }}
              />
              <SecurityScoreCell
                value={policyChecks}
                totalChecks={totalChecks}
              />
              <NumberOfNumberCell value={policyChecks} total={totalChecks} />
            </TableRow>
          );
        })}
      </AssetReportScoreDetailSection>
    </Fragment>
  );
}
